export default "__VITE_ASSET__JleFaUrT__"